import React from 'react';
import { Layout, Popover, Tooltip, Typography, Row, Col } from 'antd';
import { CloseOutlined, InfoCircleFilled } from '@ant-design/icons';
import FilterProfileDetails from '../../../../shared-components/FilterProfileDetails';
import mixpanel from 'mixpanel-browser';
import styles from './filter-sidebar.module.sass';
import cx from 'classnames';

const { Sider } = Layout;

class FilterSidebar extends React.PureComponent {
  render() {
    const { collapsed } = this.props;
    const { Title, Text } = Typography;
    const popoverContentStyle = { padding: '0 .5rem' };
    const popoverContentFirstRowStyle = {
      border: '1px solid rgba(255, 255, 255, .35)',
      padding: '.5rem 0',
      backgroundColor: '#15262B',
    };
    const popoverContentRowStyle = {
      border: '1px solid rgba(255, 255, 255, .35)',
      padding: '.5rem 0',
      borderTop: 'none',
      backgroundColor: '#15262B',
    };
    const popoverContentOperatorRowStyle = {
      border: '1px solid rgba(255, 255, 255, .35)',
      padding: '.5rem 0',
      borderTop: 'none',
      backgroundColor: '#1a2d32',
    };
    const operatorContent = { margin: 'auto' };
    const popoverTitle = {
      color: 'rgba(255, 255, 255, .95)',
      marginLeft: '-.8rem',
    };

    return (
      <Sider
        trigger={null}
        defaultCollapsed="true"
        collapsedWidth="0"
        collapsible
        collapsed={collapsed}
        width={400}
        className={cx(styles.filterSideBar, { [styles.collapsed]: collapsed })}
      >
        <div className={styles.popoverSection}>
          <div className={styles.title}>
            <Title level={4}>Advanced Filters</Title>

            <Popover
              id="andvancedFilterPopover"
              placement="topRight"
              content={
                <div style={popoverContentStyle}>
                  <Title level={5} style={popoverTitle}>
                    Here is an example how to build your own filter using
                    logical expressions with combination of multiple logical
                    expressions for more complex filters:
                  </Title>
                  <Row gutter={24} style={popoverContentFirstRowStyle}>
                    <Col xs={7}>
                      <Text>[Tag/Tag Name]</Text>
                    </Col>
                    <Col xs={4}>
                      <Text>[Is]</Text>
                    </Col>
                    <Col xs={4}>
                      <Text>[phishing]</Text>
                    </Col>
                    <Col xs={9}>
                      <Text>= Observables that contain the tag 'phishing'</Text>
                    </Col>
                  </Row>

                  <Row gutter={24} style={popoverContentOperatorRowStyle}>
                    <Col style={operatorContent}>
                      <Text>
                        Operation: <Text strong>AND</Text>
                      </Text>
                    </Col>
                  </Row>

                  <Row gutter={24} style={popoverContentRowStyle}>
                    <Col xs={7}>
                      <Text>[Sources/Last Updated]</Text>
                    </Col>
                    <Col xs={4}>
                      <Text>[Today]</Text>
                    </Col>
                    <Col xs={4}>
                      <Text>-</Text>
                    </Col>
                    <Col xs={9}>
                      <Text>= Observables collected today</Text>
                    </Col>
                  </Row>

                  <Row gutter={24} style={popoverContentOperatorRowStyle}>
                    <Col style={operatorContent}>
                      <Text>
                        Operation: <Text strong>AND</Text>
                      </Text>
                    </Col>
                  </Row>

                  <Row gutter={24} style={popoverContentRowStyle}>
                    <Col xs={7}>
                      <Text>[Flags/Is New]</Text>
                    </Col>
                    <Col xs={4}>
                      <Text>[Is]</Text>
                    </Col>
                    <Col xs={4}>
                      <Text>[True]</Text>
                    </Col>
                    <Col xs={9}>
                      <Text>
                        = Only new observables (domains not seen in any zone
                        files)
                      </Text>
                    </Col>
                  </Row>
                </div>
              }
            >
              &nbsp;
              <InfoCircleFilled />
            </Popover>
          </div>

          <Tooltip title="Close advanced filter">
            <CloseOutlined
              className={styles.closeFilterSidebar}
              onClick={() => {
                window.history.replaceState(
                  null,
                  '',
                  `/${window.location.search.replace(
                    '?openAdvancedFilter=true',
                    '',
                  )}`,
                );
                this.props.closeFilterSidebar();
                mixpanel.track('Filter Close');
              }}
            />
          </Tooltip>
        </div>

        <FilterProfileDetails collapsed={collapsed} />
      </Sider>
    );
  }
}

export default FilterSidebar;
